import AlertSummaryPanel from './AlertSummaryPanel';

export default AlertSummaryPanel;
